import React, { ChangeEvent, KeyboardEvent } from 'react';
import { Col, Row } from 'react-bootstrap';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { InputMoney, InputSelect } from '~/components/NovosInputs';
import { moedaFormatada } from '~/components/NovosInputs/InputMoney/formatMask';
import { transformAsCurrency } from '~/utils/functions';
import { useCadastroComposicao } from '../../hook/useCadastroComposicao';
import { useHandleFocus } from '../../hook/useFocus';
import { Select } from '../../types';
import { Container } from './styles';

const MySwal = withReactContent(Swal);
export const Form: React.FC = () => {
  const {
    formData,
    register,
    setValue,
    control,
    errors,
    tiposDePreco,
    tipoPrecoComposicao,
    setTipoPrecoComposicao,
    setValorTotalComposicao,
    explodeVenda,
  } = useCadastroComposicao();
  const { handleInputFocus } = useHandleFocus();
  const { cod_loja, cod_produto, des_produto } = formData;

  const codLoja = cod_loja.value;
  const codProduto = cod_produto.value;
  const desProduto = des_produto.value;

  const sweetAlertExplodeVenda = async () => {
    const result = await MySwal.fire({
      title:
        'Para informar o preço da composição, não poderá estar marcada a opção de Explosão na Venda no cadastro de produto.',
      text: 'Regularize a situação para prosseguir.',
      confirmButtonColor: '#0065FF',
      confirmButtonText: 'OK',
    });
    if (result.isConfirmed) {
      const inputElement = document.querySelector<HTMLInputElement>(
        `input[name="tipo_preco_composicao"]`,
      );
      if (inputElement) {
        inputElement.value = tipoPrecoComposicao.label;
      }
    }
  };

  const handleChangeSelected = async (selected: Select) => {
    if (selected.value !== tipoPrecoComposicao.value) {
      if (selected.value === 1 && explodeVenda) {
        return sweetAlertExplodeVenda();
      }
      const resultModal = await MySwal.fire({
        title: '',
        text: `Alternar o tipo de preço poderá atualizar valores informados anteriormente.\nDeseja realmente alternar o tipo de preço da composição?`,
        showCloseButton: false,
        confirmButtonColor: '#0065FF',
        cancelButtonColor: '#ccc',
        showDenyButton: true,
        confirmButtonText: 'SIM',
        denyButtonText: 'NÃO',
        keydownListenerCapture: true,
      });
      if (!resultModal.isConfirmed) {
        const inputElement = document.querySelector<HTMLInputElement>(
          `input[name="tipo_preco_composicao"]`,
        );
        setValue('tipo_preco_composicao', tipoPrecoComposicao);
        setTipoPrecoComposicao(tipoPrecoComposicao);
        if (inputElement) {
          inputElement.value = tipoPrecoComposicao.label;
        }
      }
      if (resultModal.isConfirmed) {
        setValue('tipo_preco_composicao', selected);
        setTipoPrecoComposicao(selected);
      }
    }
  };

  return (
    <Container>
      <Row>
        <Col sm={12} md={6}>
          <table className="table">
            <thead>
              <tr>
                <th>Loja</th>
                <th>PLU</th>
                <th>Produto</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{codLoja}</td>
                <td>{codProduto}</td>
                <td>{desProduto}</td>
              </tr>
            </tbody>
          </table>
        </Col>
        <Col sm={12} md={4}>
          <InputSelect
            id="tipo_preco_composicao"
            label="Composição de Preço"
            placeholder="Selecione..."
            name="tipo_preco_composicao"
            control={control}
            register={register}
            options={tiposDePreco}
            isError={!!errors.tipo_preco_composicao}
            changeSelected={(selected: Select) => {
              handleChangeSelected(selected);
            }}
          />
        </Col>
        <Col sm={12} md={2}>
          <InputMoney
            id="val_preco"
            label="Preço de Venda"
            placeholder="0,00"
            name="val_preco"
            min={0}
            max={99999}
            maxLength={15}
            disabled={tipoPrecoComposicao.value !== 1}
            control={control}
            register={register}
            isError={!!errors.val_preco}
            onInput={(ev: ChangeEvent<HTMLInputElement>) => {
              const { value } = ev.target;
              setValue('val_preco', value);
              setValorTotalComposicao(
                transformAsCurrency(moedaFormatada(value, 2)),
              );
            }}
            onKeyPress={async (event: KeyboardEvent) => {
              if (event.key === 'Enter') {
                handleInputFocus('cod_produto');
              }
            }}
          />
        </Col>
      </Row>
    </Container>
  );
};
